import React from "react";
import { Col, Modal, Row, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";

const { Title } = Typography;

const ConfirmModal = ({
  showModal,
  setShowModal,
  onDeleteConfirm,
  setSelectedRowKeys,
  content,
}) => {
  const handleOk = () => {
    onDeleteConfirm();
    setShowModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
    setSelectedRowKeys && setSelectedRowKeys([]);
  };

  return (
    <Modal
      open={showModal}
      onOk={handleOk}
      onCancel={handleCancel}
      closable={false}
      width={480}
      centered
      footer={null} // Remove default buttons to use custom styling
    >
      <div className="flex pt-4 pb-2 flex-col font-['Poppins'] items-center justify-center text-center w-full">
        {/* Icon + Text Container */}
        <div className="flex items-center gap-x-4 w-full px-4">
          {/* Warning Icon */}
          <span className="flex items-center justify-center w-10 h-10  bg-yellow-100 text-yellow-600 rounded-full flex-shrink-0">
            <WarningOutlined className="text-2xl" />
          </span>

          {/* Text with flexible width */}
          <p className="text-[15px] font-medium leading-6 text-black">
            {content || "Do you want to Delete?"}
          </p>
        </div>

        {/* Buttons at the bottom */}
        <div className="flex justify-end space-x-3 mt-4 w-full px-1">
          <button
            onClick={handleOk}
            className="px-6 py-1 text-[14px] bg-[#007BFF] text-white rounded-md hover:bg-white hover:text-[#007BFF] transition shadow-none hover:shadow-[0_4px_12px_rgba(0,0,0,0.25)]"
          >
            Yes
          </button>
          <button
            onClick={handleCancel}
            className="px-6 py-1 text-[14px] text-white bg-red-600 rounded-md hover:bg-white hover:text-red-600 transition shadow-none hover:shadow-[0_4px_12px_rgba(0,0,0,0.25)]"
          >
            No
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
